<ul [ngClass]="paginationClass">
  <ng-content></ng-content>
</ul>
